import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  badge: {
    minWidth: idsTokens.badge.default.spacing.standard.min.pillWidth,
    height: idsTokens.badge.default.spacing.standard.min.pillHeight,
    borderRadius: idsTokens.badge.default.radius.pill,
    boxShadow: '0px 6px 12px -8px rgba(0, 0, 0, 0.06)',
    fontSize: idsTokens.typography.font.size.base,
    fontWeight: idsTokens.typography.font.weight.bold,
    lineHeight: '16px',
    letterSpacing: idsTokens.typography.spacing.letter.none,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    top: -10,
    right: -8,
    transform: 'none',
    paddingBottom: 1,
  },
  dot: {
    height: `calc(${idsTokens.badge.default.spacing.standard.min.dotWidth} - 8px)`,
    minWidth: `calc(${idsTokens.badge.default.spacing.standard.min.dotHeight} - 8px)`,
    zIndex: 100,
    filter: 'drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.12))',
    top: -4,
    right: -4,
  },
});
